import React from 'react';
import { Watch } from 'react-loader-spinner';

const LoadingQuote = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-75">
      <div className="loading-section">
        <Watch
          visible={true}
          height="40"
          width="40"
          radius="48"
          color="#4fa94d"
          ariaLabel="watch-loading"
          wrapperStyle={{}}
          wrapperClass="watch-load"
        />
        <p className="loading-text">
          "The two most powerful warriors are patience and time." – Leo Tolstoy
        </p>
      </div>
    </div>
  );
};

export default LoadingQuote;
